import { useState } from "react";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

type Props = {
  id?: string;
  icon: React.ReactNode;
  label?: string;
  className?: string;
  onClick?: () => void;
};

export default function MenuItem({
  label = "",
  id = "",
  icon,
  className = "",
  onClick,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const { color2 } = useAppSelector(selectStyle);
  return (
    <li
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        color: (hovered ? color2 : "") }}    
      className={`flex flex-row items-center justify-start py-2 gap-x-1 font-bold cursor-pointer select-none transition-colors ${className}`}
      id={id}
      onClick={onClick}
    >
      {icon}
      <p 
      id={id}
      className="leading-5 h-5 p-red hover:text-green">
      {label}
      </p>
    </li>
  );
}
